import { render } from "./Resume.vue?vue&type=template&id=34169288"
import script from "./Resume.vue?vue&type=script&lang=js"
export * from "./Resume.vue?vue&type=script&lang=js"
script.render = render

export default script